import {Directive, Inject, Input, Optional, SkipSelf} from '@angular/core';
import {AbstractControl, ControlContainer, NG_VALIDATORS, ValidationErrors, Validator} from '@angular/forms';
import {takeUntil} from 'rxjs/operators';
import {VALIDATION_SKIP_DEFAULT_RULES, ValidationItemBaseDirective} from './validation-item-base.directive';
import {VALIDATION_CONTEXTS, ValidationContext} from '../../data/validation-context';

@Directive({
    // tslint:disable-next-line:directive-selector
    selector: '[ngModelGroup]',
    exportAs: 'validationItem',
    providers: [
        {
            provide: NG_VALIDATORS,
            useExisting: ValidationGroupDirective,
            multi: true,
        }
    ]
})
export class ValidationGroupDirective extends ValidationItemBaseDirective implements Validator {
    // Since there is an issue for ngModelGroup with not calling registerOnValidatorChange to register changes. Workaround should be used.
    private lastValidatedControl: AbstractControl;

    constructor(
        @Inject(VALIDATION_CONTEXTS) @SkipSelf()
            $validationContexts: Array<ValidationContext>,
        @Inject(VALIDATION_SKIP_DEFAULT_RULES) @SkipSelf() @Optional()
        private readonly defaultSkipRules: Array<string> = [],
        @SkipSelf() @Optional()
            $controlContainer?: ControlContainer,
    ) {
        super($validationContexts, $controlContainer);

        // Update value and validity each time validation rules are changed.
        this.rules$
            .pipe(
                takeUntil(this.us$),
            )
            .subscribe(() => {
                if (this.lastValidatedControl) {
                    this.lastValidatedControl.updateValueAndValidity();
                }
            });
    }

    protected constructUnexpectedWarn(): string {
        return `Unexpected empty rule on field: ${this.name}.`;
    }

    public validate($control: AbstractControl): ValidationErrors | null {
        // Save last validated control to update its validity when rules will be changed.
        this.lastValidatedControl = $control;
        return super.validate($control);
    }

    @Input('ngModelGroup')
    public set name($value: string) {
        this.name$.next($value);
    }

    public get name(): string {
        return this.name$.value;
    }

    @Input()
    public set skipRules($value: Array<string>) {
        this.skipRules$.next(
            typeof $value === 'object' && Array.isArray($value)
                ? $value
                : this.defaultSkipRules
        );
    }

    public get skipRules(): Array<string> {
        return this.skipRules$.value;
    }
}
